var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.timingType == 1)?_c('span',[_vm._v(_vm._s(_vm.timeNumber))]):_vm._e(),(_vm.timingType == 2)?_c('div',{staticClass:"_base-count-down"},[_c('div',{staticClass:"content"},[_vm._t("default",null,null,{
      d: _vm.days, h: _vm.hours, m: _vm.mins, s: _vm.seconds,
      hh: ("00" + _vm.hours).slice(-2),
      mm: ("00" + _vm.mins).slice(-2),
      ss: ("00" + _vm.seconds).slice(-2),
    })],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }